import { gql } from '@apollo/client';
import { searchCombo } from 'api/fragments';

export const fetchExitRulesQuery = gql`
  ${searchCombo}
  query FetchExitRules($workflowId: Long!, $workflowType: WorkflowType, $includeArchived: Boolean) {
    workflow(id: $workflowId, workflowType: $workflowType) {
      exitRules(includeArchived: $includeArchived) {
        __typename
        ... on ConversionMetExitRule {
          id
          eventName
          enabledDate
          archivedDate
          containsCloningError
          searchQuery {
            ...SearchComboFragment
            __typename
          }
          journeyConversionRuleMetadata {
            journeyConversionId
          }
          sendToJourneyMetadata {
            destinationId
          }
          __typename
        }
        ... on CustomEventExitRule {
          id
          eventName
          enabledDate
          archivedDate
          containsCloningError
          searchQuery {
            ...SearchComboFragment
          }
          sendToJourneyMetadata {
            destinationId
          }
        }
        ... on SystemEventExitRule {
          id
          eventType
          enabledDate
          archivedDate
          containsCloningError
          searchQuery {
            ...SearchComboFragment
          }
          sendToJourneyMetadata {
            destinationId
          }
        }
        ... on UserPropertyExitRule {
          id
          userField
          enabledDate
          archivedDate
          containsCloningError
          searchQuery {
            ...SearchComboFragment
          }
          sendToJourneyMetadata {
            destinationId
          }
        }

        ... on ExitRuleCombo {
          id
          combinator
          enabledDate
          archivedDate
          containsCloningError
          rules {
            ... on CustomEventExitRule {
              id
              eventName
              searchQuery {
                ...SearchComboFragment
              }
              sendToJourneyMetadata {
                destinationId
              }
            }
            ... on SystemEventExitRule {
              id
              eventType
              searchQuery {
                ...SearchComboFragment
              }
              sendToJourneyMetadata {
                destinationId
              }
            }
            ... on UserPropertyExitRule {
              id
              userField
              searchQuery {
                ...SearchComboFragment
              }
              sendToJourneyMetadata {
                destinationId
              }
            }
          }
          sendToJourneyMetadata {
            destinationId
          }
        }
      }
    }
  }
`;

export const fetchCloningErrorsExitRulesQuery = gql`
  query FetchCloningErrorsExitRules(
    $workflowId: Long!
    $workflowType: WorkflowType
    $includeArchived: Boolean
  ) {
    workflow(id: $workflowId, workflowType: $workflowType) {
      exitRules(includeArchived: $includeArchived) {
        ... on CustomEventExitRule {
          containsCloningError
        }
        ... on SystemEventExitRule {
          containsCloningError
        }
        ... on UserPropertyExitRule {
          containsCloningError
        }

        ... on ExitRuleCombo {
          containsCloningError
        }
      }
    }
  }
`;
